webpackJsonp([19],{

/***/ 776:
/*!************************************************!*\
  !*** ./node_modules/lodash/_isIterateeCall.js ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(/*! ./eq */ 121),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 72),
    isIndex = __webpack_require__(/*! ./_isIndex */ 129),
    isObject = __webpack_require__(/*! ./isObject */ 51);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 808:
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseRest.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(/*! ./identity */ 123),
    overRest = __webpack_require__(/*! ./_overRest */ 736),
    setToString = __webpack_require__(/*! ./_setToString */ 737);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 816:
/*!**************************************************!*\
  !*** ./node_modules/lodash/isArrayLikeObject.js ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(/*! ./isArrayLike */ 72),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 37);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 836:
/*!******************************************!*\
  !*** ./node_modules/lodash/mapValues.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ 390),
    baseForOwn = __webpack_require__(/*! ./_baseForOwn */ 415),
    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 120);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ 837:
/*!**************************************!*\
  !*** ./node_modules/lodash/keyBy.js ***!
  \**************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ 390),
    createAggregator = __webpack_require__(/*! ./_createAggregator */ 417);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),

/***/ 838:
/*!****************************************!*\
  !*** ./node_modules/lodash/isEqual.js ***!
  \****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(/*! ./_baseIsEqual */ 133);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 866:
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/products/ProductVariantForm.vue ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/extends */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(/*! lodash/get */ 413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_merge__ = __webpack_require__(/*! lodash/merge */ 931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omit__ = __webpack_require__(/*! lodash/omit */ 738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_keyBy__ = __webpack_require__(/*! lodash/keyBy */ 837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__(/*! lodash/map */ 731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_mapValues__ = __webpack_require__(/*! lodash/mapValues */ 836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEqual__ = __webpack_require__(/*! lodash/isEqual */ 838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_pick__ = __webpack_require__(/*! lodash/pick */ 835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_types__ = __webpack_require__(/*! ../../common/types */ 790);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormStickyHeader: function FormStickyHeader() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! ../../components/FormStickyHeader */ 396));
    },
    FormFileUpload: function FormFileUpload() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! ../../components/FormFileUpload */ 403));
    },
    FormSelectColor: function FormSelectColor() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! ../../components/FormSelectColor */ 414));
    },
    MediaImage: function MediaImage() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! ../../components/MediaImage */ 409));
    },
    FormSwitch: function FormSwitch() {
      return __webpack_require__.e/* import() */(18/* duplicate */).then(__webpack_require__.bind(null, /*! package-common-vuejs/src/components/form/FormSwitch */ 791));
    },
    FormMultiselect: function FormMultiselect() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, /*! package-common-vuejs/src/components/form/FormMultiselect */ 711));
    },
    OptionHtml: function OptionHtml() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! ../../components/OptionHtml */ 142));
    }
  },
  props: {
    title: String,
    value: Object,
    product: Object
  },
  data: function data() {
    return {
      model: {},
      modelAttributes: {},
      isDuplicate: false,

      selectedPinIndex: 0,
      repositionningPin: false,

      ProductPropertySexOptionsArray: __WEBPACK_IMPORTED_MODULE_9__common_types__["f" /* ProductPropertySexOptionsArray */]
    };
  },
  created: function created() {
    this.updateModel(this.value);
  },

  watch: {
    value: function value() {
      this.updateModel(this.value);
    },
    "model.message": function modelMessage() {
      if (this.model.message && !this.model.messageType) this.model.messageType = "info";
      if (!this.model.message) this.model.messageType = "";
    }
  },
  computed: {
    productProperties: function productProperties() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()((this.product && this.product.properties || []).filter(function (_ref) {
        var kind = _ref.kind;
        return kind !== "text";
      }), "id");
    },
    variantImage: function variantImage() {
      var _this = this;

      return this.product.images.find(function (_ref2) {
        var id = _ref2.id;
        return id === _this.model.image;
      });
    }
  },
  methods: {
    handleClickToPin: function handleClickToPin(event) {
      var xMouse = event.offsetX;
      var yMouse = event.offsetY;
      var x = xMouse / event.target.offsetWidth;
      var y = yMouse / event.target.offsetHeight;
      if (this.repositionningPin) {
        this.model.pins.splice(this.selectedPinIndex, 1, __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, this.model.pins[this.selectedPinIndex], {
          x: x,
          y: y
        }));
        this.repositionningPin = false;
      } else {
        this.model.pins.push({ x: x, y: y });
        this.selectedPinIndex = this.model.pins.length - 1;
      }
    },
    removePin: function removePin(index) {
      this.model.pins.splice(index, 1);
    },
    uploadSelectedPinImage: function uploadSelectedPinImage(image) {
      this.model.pins.splice(this.selectedPinIndex, 1, __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, this.model.pins[this.selectedPinIndex], {
        image: image
      }));
    },
    updateModel: function updateModel(value) {
      this.model = __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, value || {}, {
        image: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(value, "image.id"),
        pins: value.pins.map(function (pin) {
          return __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, pin, {
            image: pin.image && pin.image.id
          });
        }) || []
      });
      __WEBPACK_IMPORTED_MODULE_2_lodash_merge___default()(this.modelAttributes, __WEBPACK_IMPORTED_MODULE_6_lodash_mapValues___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_keyBy___default()((value || {}).attributes, "property"), "value"));
    },
    getOptionsFromTags: function getOptionsFromTags(tags) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(tags, function (tag) {
        return { value: tag, label: tag };
      });
    },
    testIsDuplicate: function testIsDuplicate() {
      var propertiesToFind = this.productProperties;
      var attributesToFindObject = __WEBPACK_IMPORTED_MODULE_8_lodash_pick___default()(this.modelAttributes, propertiesToFind);
      var existingVariant = (this.product && this.product.variants || []).find(function (_ref3) {
        var attributes = _ref3.attributes;

        var attributesObject = __WEBPACK_IMPORTED_MODULE_8_lodash_pick___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_mapValues___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_keyBy___default()(attributes, "property"), "value"), propertiesToFind);
        return __WEBPACK_IMPORTED_MODULE_7_lodash_isEqual___default()(attributesObject, attributesToFindObject);
      });
      this.isDuplicate = existingVariant && existingVariant.id !== this.value.id;
    },
    onSubmit: function onSubmit() {
      this.$emit("submit", __WEBPACK_IMPORTED_MODULE_3_lodash_omit___default()(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, this.model, {
        attributes: __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(this.modelAttributes, function (value, property) {
          return {
            property: property,
            value: value
          };
        }),
        pins: __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(this.model.pins, function (pin) {
          return __WEBPACK_IMPORTED_MODULE_3_lodash_omit___default()(pin, "__typename");
        })
      }), ["__typename"]));
    },
    onUploadedNewImage: function onUploadedNewImage(newImage) {
      this.model.image = newImage;
    }
  }
});

/***/ }),

/***/ 867:
/*!**************************************************!*\
  !*** ./node_modules/lodash/_assignMergeValue.js ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ 390),
    eq = __webpack_require__(/*! ./eq */ 121);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 868:
/*!*****************************************!*\
  !*** ./node_modules/lodash/_safeGet.js ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 929:
/*!***************************************************!*\
  !*** ./src/pages/products/ProductVariantForm.vue ***!
  \***************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProductVariantForm_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductVariantForm.vue */ 866);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c98bafde_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductVariantForm_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-c98bafde","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductVariantForm.vue */ 936);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-c98bafde","scoped":false,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProductVariantForm.vue */ 930)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProductVariantForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c98bafde_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductVariantForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 930:
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c98bafde","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/products/ProductVariantForm.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 931:
/*!**************************************!*\
  !*** ./node_modules/lodash/merge.js ***!
  \**************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(/*! ./_baseMerge */ 932),
    createAssigner = __webpack_require__(/*! ./_createAssigner */ 935);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 932:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseMerge.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(/*! ./_Stack */ 126),
    assignMergeValue = __webpack_require__(/*! ./_assignMergeValue */ 867),
    baseFor = __webpack_require__(/*! ./_baseFor */ 139),
    baseMergeDeep = __webpack_require__(/*! ./_baseMergeDeep */ 933),
    isObject = __webpack_require__(/*! ./isObject */ 51),
    keysIn = __webpack_require__(/*! ./keysIn */ 388),
    safeGet = __webpack_require__(/*! ./_safeGet */ 868);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 933:
/*!***********************************************!*\
  !*** ./node_modules/lodash/_baseMergeDeep.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(/*! ./_assignMergeValue */ 867),
    cloneBuffer = __webpack_require__(/*! ./_cloneBuffer */ 740),
    cloneTypedArray = __webpack_require__(/*! ./_cloneTypedArray */ 742),
    copyArray = __webpack_require__(/*! ./_copyArray */ 741),
    initCloneObject = __webpack_require__(/*! ./_initCloneObject */ 743),
    isArguments = __webpack_require__(/*! ./isArguments */ 124),
    isArray = __webpack_require__(/*! ./isArray */ 11),
    isArrayLikeObject = __webpack_require__(/*! ./isArrayLikeObject */ 816),
    isBuffer = __webpack_require__(/*! ./isBuffer */ 125),
    isFunction = __webpack_require__(/*! ./isFunction */ 141),
    isObject = __webpack_require__(/*! ./isObject */ 51),
    isPlainObject = __webpack_require__(/*! ./isPlainObject */ 744),
    isTypedArray = __webpack_require__(/*! ./isTypedArray */ 140),
    safeGet = __webpack_require__(/*! ./_safeGet */ 868),
    toPlainObject = __webpack_require__(/*! ./toPlainObject */ 934);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 934:
/*!**********************************************!*\
  !*** ./node_modules/lodash/toPlainObject.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ 727),
    keysIn = __webpack_require__(/*! ./keysIn */ 388);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 935:
/*!************************************************!*\
  !*** ./node_modules/lodash/_createAssigner.js ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(/*! ./_baseRest */ 808),
    isIterateeCall = __webpack_require__(/*! ./_isIterateeCall */ 776);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 936:
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c98bafde","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/products/ProductVariantForm.vue ***!
  \****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('row',[_c('column',{attrs:{"sm":"6"}},[_c('form-group',{attrs:{"label":"Référence produit"}},[_c('form-input',{attrs:{"type":"text","placeholder":"Ex : E12103"},model:{value:(_vm.model.reference),callback:function ($$v) {_vm.$set(_vm.model, "reference", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"model.reference"}})],1)],1),_vm._v(" "),_c('column',{attrs:{"sm":"6"}},[_c('form-group',{attrs:{"label":" "}},[_c('form-switch',{model:{value:(_vm.model.published),callback:function ($$v) {_vm.$set(_vm.model, "published", $$v)},expression:"model.published"}},[_vm._v("Publier cette déclinaison")])],1)],1)],1),_vm._v(" "),_c('form-group',{attrs:{"label":"Description"}},[_c('form-textarea',{attrs:{"placeholder":""},model:{value:(_vm.model.description),callback:function ($$v) {_vm.$set(_vm.model, "description", $$v)},expression:"model.description"}})],1),_vm._v(" "),_c('form-group',{attrs:{"label":"Message affiché lors de la sélection du produit"}},[_c('form-input',{attrs:{"type":"text"},model:{value:(_vm.model.message),callback:function ($$v) {_vm.$set(_vm.model, "message", $$v)},expression:"model.message"}}),_vm._v(" "),_c('form-radio',{staticClass:"display-inline-block mr-10",attrs:{"required":_vm.model.message,"name":"messageType","value":"notice"},model:{value:(_vm.model.messageType),callback:function ($$v) {_vm.$set(_vm.model, "messageType", $$v)},expression:"model.messageType"}},[_vm._v("\n      Discret")]),_vm._v(" "),_c('form-radio',{staticClass:"display-inline-block mr-10",attrs:{"required":_vm.model.message,"name":"messageType","value":"info"},model:{value:(_vm.model.messageType),callback:function ($$v) {_vm.$set(_vm.model, "messageType", $$v)},expression:"model.messageType"}},[_vm._v("\n      Information")]),_vm._v(" "),_c('form-radio',{staticClass:"display-inline-block",attrs:{"required":_vm.model.message,"name":"messageType","value":"warning"},model:{value:(_vm.model.messageType),callback:function ($$v) {_vm.$set(_vm.model, "messageType", $$v)},expression:"model.messageType"}},[_vm._v("\n      Avertissement")])],1),_vm._v(" "),_c('form-group',{attrs:{"label":"Image"}},[_c('row',_vm._l((_vm.product.images),function(image){return _c('column',{key:image.id,attrs:{"lg":"4","sm":"6"}},[_c('figure',{staticClass:"thumbnail cursor-pointer",on:{"click":function($event){_vm.model.image = image.id}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.image === image.id),expression:"model.image === image.id"}],staticClass:"icon-check bg-success"}),_vm._v(" "),_c('img',{staticClass:"img-thumbnail img-rounded",class:{ 'border-success': _vm.model.image === image.id },attrs:{"src":_vm._f("media")(image,'admin-thumbnail'),"width":"95","height":"70","alt":image.alt || image.name}}),_vm._v(" "),_c('figcaption',[_vm._v(_vm._s(image.name))])])])}),1),_vm._v(" "),_c('form-file-upload',{attrs:{"image":""},on:{"input":_vm.onUploadedNewImage}}),_vm._v(" "),_c('p',{attrs:{"slot":"help"},slot:"help"},[_vm._v("\n      Choisissez parmi un fichier existant ou envoyez une nouvelle image\n    ")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('row',_vm._l((_vm.product.properties),function(prop,propIndex){return _c('column',{key:prop.id || propIndex,attrs:{"lg":"6"}},[_c('form-group',{attrs:{"label":prop.name,"warning":_vm.isDuplicate,"required":prop.required}},[(prop.kind === 'color')?_c('form-select-color',{attrs:{"colors":prop.colors,"buttonClass":_vm.isDuplicate ? "btn btn-warning" : "","placeholder":prop.required ? "Choisir..." : "Aucune","required":prop.required},on:{"input":_vm.testIsDuplicate},model:{value:(_vm.modelAttributes[prop.id]),callback:function ($$v) {_vm.$set(_vm.modelAttributes, prop.id, $$v)},expression:"modelAttributes[prop.id]"}}):_vm._e(),_vm._v(" "),(prop.kind === 'sex')?_c('form-select',{attrs:{"options":_vm.ProductPropertySexOptionsArray,"placeholder":prop.required ? "Choisir..." : "Aucun","required":prop.required},on:{"input":_vm.testIsDuplicate},model:{value:(_vm.modelAttributes[prop.id]),callback:function ($$v) {_vm.$set(_vm.modelAttributes, prop.id, $$v)},expression:"modelAttributes[prop.id]"}}):_vm._e(),_vm._v(" "),(prop.kind === 'tag')?_c('form-select',{attrs:{"options":_vm.getOptionsFromTags(prop.tags),"placeholder":prop.required ? "Choisir..." : "Aucun","required":prop.required},on:{"input":_vm.testIsDuplicate},model:{value:(_vm.modelAttributes[prop.id]),callback:function ($$v) {_vm.$set(_vm.modelAttributes, prop.id, $$v)},expression:"modelAttributes[prop.id]"}}):_vm._e(),_vm._v(" "),(prop.kind === 'text')?_c('form-input',{attrs:{"type":"text","placeholder":"Entrer un texte","required":prop.required},on:{"input":_vm.testIsDuplicate},model:{value:(_vm.modelAttributes[prop.id]),callback:function ($$v) {_vm.$set(_vm.modelAttributes, prop.id, (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"modelAttributes[prop.id]"}}):_vm._e()],1)],1)}),1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDuplicate),expression:"isDuplicate"}],staticClass:"text-warning text-semibold"},[_vm._v("\n    Cette combinaison de propriétés est déjà définie dans une déclinaison.\n  ")]),_vm._v(" "),(_vm.variantImage)?[_c('hr'),_vm._v(" "),_c('row',[_c('column',{attrs:{"lg":"6"}},[_c('form-group',{attrs:{"label":"Zoom"}},[_c('div',{staticClass:"pin-container"},[_c('img',{staticClass:"img-thumbnail img-rounded",attrs:{"src":_vm._f("media")(_vm.variantImage,'admin-preview'),"width":"285","height":"210","alt":_vm.variantImage.alt || _vm.variantImage.name},on:{"click":_vm.handleClickToPin}}),_vm._v(" "),_vm._l((_vm.model.pins),function(ref,index){
var x = ref.x;
var y = ref.y;
return _c('div',{key:index,staticClass:"pin",class:{
                selected: index === _vm.selectedPinIndex,
                disabled: _vm.repositionningPin,
              },style:({
                left: x * 100 + '%',
                top: y * 100 + '%',
              }),on:{"click":function($event){_vm.selectedPinIndex = index}}},[_vm._v("\n              "+_vm._s(index + 1)+"\n            ")])})],2)])],1),_vm._v(" "),_c('column',{attrs:{"lg":"6"}},[_c('table',{staticClass:"table table-striped table-hover table-condensed"},[_c('thead',[_c('tr',[_c('td',[_vm._v("Point")]),_vm._v(" "),_c('td',[_vm._v("Action")])])]),_vm._v(" "),(_vm.model.pins && _vm.model.pins.length)?_c('tbody',_vm._l((_vm.model.pins),function(ref,index){
              var image = ref.image;
return _c('tr',{key:index,staticClass:"selectable-row",class:{ info: _vm.selectedPinIndex === index },on:{"click":function($event){_vm.selectedPinIndex = index}}},[_c('td',{attrs:{"width":"100%"}},[_vm._v("\n                "+_vm._s(index + 1)+"\n                "),(!image)?_c('span',{staticClass:"text-warning"},[_vm._v("\n                  (aucune image)\n                ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-danger btn-xs",attrs:{"type":"button"},on:{"click":function($event){return _vm.removePin(index)}}},[_c('i',{staticClass:"icon-trash"})])])])}),0):_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_vm._v("\n                Aucun point créé. Vous pouvez en créer un en cliquant sur\n                l'image ci-contre.\n              ")])])])]),_vm._v(" "),(_vm.model.pins && _vm.model.pins[_vm.selectedPinIndex])?[_c('hr'),_vm._v(" "),_c('h5',[_vm._v("Point sélectionné :")]),_vm._v(" "),_c('form-group',{attrs:{"label":"Image du point"}},[_c('form-file-upload',{key:_vm.selectedPinIndex,attrs:{"value":_vm.model.pins[_vm.selectedPinIndex].image,"image":""},on:{"input":_vm.uploadSelectedPinImage}}),_vm._v(" "),_c('p',{attrs:{"slot":"help"},slot:"help"},[_vm._v("Format d'image recommandé : JPG 1490x900px")])],1),_vm._v(" "),_c('button',{staticClass:"btn",class:{ 'btn-primary': _vm.repositionningPin },attrs:{"type":"button"},on:{"click":function($event){_vm.repositionningPin = !_vm.repositionningPin}}},[_vm._v("\n            Repositionner le point\n          ")])]:_vm._e()],2)],1)]:_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form-button',{attrs:{"disabled":_vm.isDuplicate,"kind":"submit","type":"submit"}},[_vm._v("Enregistrer")]),_vm._v(" "),_c('form-button',{attrs:{"kind":"cancel"},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("Annuler")])],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// 19.d191e0ff.chunk.js